import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { Container } from './styled'
import TypeFilter from './type'
import ChannelFilter from './channel'
import DateFilter from './date'
import DepartmentFilter from './department'
import DepartmentSelectFilter from './departmentSelect'
import QueueFilter from './queue'
import UserFilter from './user'
import PerFilter from './per'
import TypeUserFilter from './typeUserFilter'
import LogFilter from './idTypeLog'

// Assets
import { ReactComponent as Close } from 'images/icons/close.svg'
import { ReactComponent as FilterIcon } from 'images/icons/filter.svg'

import { Button } from '../../parts/button/'
import Scrollbar from '../../parts/scrollbar/index'
import  {Switch,FormControlLabel} from '../../page/workflow/kanban/option/style'
const Filter = (props) => {
	const { size, order, showFilter, setShowFilter, onFilter } = props.filter
	const filterContainer = useRef(null)
	
	
	function mountFilter(x, i) {
	
		switch (x) {
			case 'type':
				return (
					<TypeFilter key={`filter_${i}`} count={props.countType} filter={props.filter} />
					)
			case 'date':
				return <DateFilter key={`filter_${i}`} t={props.tDash} filter={props.filter} />
			case 'type_user':
				return <TypeUserFilter key={`filter_${i}`} t={props.t} filter={props.filter} />
			case 'channel':
				return (
					<ChannelFilter
						key={`filter_${i}`}
						t={props.t}
						department={props.department}
						count={props.count}
						filter={props.filter}
					/>
				)
			case 'department':
				return (
					props.department && (
						<DepartmentFilter
							key={`filter_${i}`}
							t={props.t}
							department={props.department}
							workflow={props.workflow}
							count={props.count}
							filter={props.filter}
						/>
					)
				)
			case 'departmentSelect':
				return (
					props.department && (
						<DepartmentSelectFilter
							key={`filter_${i}`}
							t={props.t}
							department={props.department}
							workflow={props.workflow}
							count={props.count}
							filter={props.filter}
						/>
					)
				)
			case 'user':
				return (
					props.user && (
						<UserFilter
							key={`filter_${i}`}
							t={props.t}
							user={props.user}
							filter={props.filter}
						/>
						)
						)
			case 'queue':
				return (
					<QueueFilter
						key={`filter_${i}`}
						t={props.t}
						count={props.count}
						filter={props.filter}
					/>
				)
			case 'per':
				return (
					<PerFilter
						key={`filter_${i}`}
						t={props.t}
						count={props.count}
						filter={props.filter}
					/>
				)
			case 'id_type':
				return (
						<LogFilter
							key={`filter_${i}`}
							t={props.t}
							count={props.count}
							filter={props.filter}
						/>
				)

			case 'button':
				return (
					<Button
						key={`filter_${i}`}
						variant="contained"
						onClick={() => onFilter(true)}
						color="primary"
					>
						{props?.tDash?.filterBy}
					</Button>
				)
				case 'history_phase':
				return (
					
					<FormControlLabel
						control={
							<Switch size="medium" checked={!props.filter.history} onChange={() => {
							props.filter.setHistory(!props.filter.history)
							props.filter.setFilter({...props.filter.filter, history_phase: props.filter.history })
							}} 
							/>}
						label={`${props?.tDash?.viewHistoric}`}
					/>
				)
			default:
				return console.log('filter not exists')
		}
	}
	size.height =
		size.height &&
		size.height === 'fit' &&
		`${
			(filterContainer.current && filterContainer.current.offsetHeight > 0
				? filterContainer.current.offsetHeight
				: 450) + 78
		}px`
	return (
		<>
			<Button secondary onClick={() => setShowFilter(!showFilter)}>
				<FilterIcon />
				{props?.tDash?.filterBy}
			</Button>
			<Container size={size} showFilter={showFilter}>
				<div className="header">
					<h4>{props?.tDash?.filterBy}</h4>
					<Close onClick={() => setShowFilter(false)} />
				</div>
				<Scrollbar container={{ padding: '10px 0', width: '100%', height: '100%' }}>
					<div className="main" ref={filterContainer}>
						{Array.isArray(order) && order.map((x, i) => mountFilter(x, i))}
					</div>
				</Scrollbar>
			</Container>
		</>
	)
}

const mapStateToProps = (state) => ({
	tDash: state.i18nState.translations[state.i18nState.lang]['Dashboard'],
})

export default connect(mapStateToProps)(Filter)
